import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';
import translations from '@/data/translations';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { lang, toggleLanguage, getLocalizedPath } = useLanguage();
  const location = useLocation();
  const nav = translations.nav[lang];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const isHome = location.pathname === '/' || location.pathname === '/es';

  return (
    <>
      <nav className={`bl-nav ${scrolled ? 'scrolled' : ''}`} data-testid="navbar">
        <Link to={getLocalizedPath('/')} className="bl-nav-logo">
          <img src="/blackline-logo-cropped.png" alt="Blackline Premium Solutions" className="bl-nav-logo-img" />
        </Link>
        <ul className="bl-nav-links">
          {isHome ? (
            <>
              <li><a href="#products" onClick={(e) => { e.preventDefault(); scrollTo('products'); }}>{nav.products}</a></li>
              <li><a href="#why" onClick={(e) => { e.preventDefault(); scrollTo('why'); }}>{nav.why}</a></li>
              <li><a href="#gallery" onClick={(e) => { e.preventDefault(); scrollTo('gallery'); }}>{nav.projects}</a></li>
              <li><a href="#catalog" onClick={(e) => { e.preventDefault(); scrollTo('catalog'); }}>{nav.catalog}</a></li>
              <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}>{nav.contact}</a></li>
            </>
          ) : (
            <>
              <li><Link to={getLocalizedPath('/')}>{nav.products}</Link></li>
              <li><Link to={getLocalizedPath('/about')}>{lang === 'es' ? 'Nosotros' : 'About'}</Link></li>
              <li><Link to={getLocalizedPath('/for-builders')}>{lang === 'es' ? 'Constructores' : 'Builders'}</Link></li>
              <li><Link to={getLocalizedPath('/for-architects')}>{lang === 'es' ? 'Arquitectos' : 'Architects'}</Link></li>
            </>
          )}
          <li>
            <button className="lang-toggle" onClick={toggleLanguage} data-testid="lang-toggle">
              {lang === 'en' ? 'ES' : 'EN'}
            </button>
          </li>
          <li>
            {isHome ? (
              <a href="#contact" className="btn-gold-nav" onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}>{nav.quote}</a>
            ) : (
              <Link to={getLocalizedPath('/')} className="btn-gold-nav">{nav.quote}</Link>
            )}
          </li>
        </ul>
        <button className="bl-nav-hamburger" onClick={() => setMobileOpen(true)} aria-label="Menu">
          <Menu size={24} color="white" />
        </button>
      </nav>

      {/* Mobile Menu */}
      <div className={`bl-mobile-menu ${mobileOpen ? 'open' : ''}`}>
        <button className="bl-mobile-close" onClick={() => setMobileOpen(false)}><X size={28} /></button>
        {isHome ? (
          <>
            <a href="#products" onClick={(e) => { e.preventDefault(); scrollTo('products'); }}>{nav.products}</a>
            <a href="#why" onClick={(e) => { e.preventDefault(); scrollTo('why'); }}>{nav.why}</a>
            <a href="#gallery" onClick={(e) => { e.preventDefault(); scrollTo('gallery'); }}>{nav.projects}</a>
            <a href="#catalog" onClick={(e) => { e.preventDefault(); scrollTo('catalog'); }}>{nav.catalog}</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}>{nav.contact}</a>
          </>
        ) : (
          <>
            <Link to={getLocalizedPath('/')} onClick={() => setMobileOpen(false)}>{lang === 'es' ? 'Inicio' : 'Home'}</Link>
            <Link to={getLocalizedPath('/about')} onClick={() => setMobileOpen(false)}>{lang === 'es' ? 'Nosotros' : 'About'}</Link>
            <Link to={getLocalizedPath('/for-builders')} onClick={() => setMobileOpen(false)}>{lang === 'es' ? 'Constructores' : 'Builders'}</Link>
            <Link to={getLocalizedPath('/for-architects')} onClick={() => setMobileOpen(false)}>{lang === 'es' ? 'Arquitectos' : 'Architects'}</Link>
          </>
        )}
        <button className="lang-toggle" onClick={() => { toggleLanguage(); setMobileOpen(false); }} style={{ color: 'var(--gold)', fontSize: '1rem', padding: '0.8rem 1.5rem', border: '1px solid var(--gold)', borderRadius: '4px', marginTop: '1rem' }}>
          {lang === 'en' ? 'Cambiar a Espa\u00f1ol' : 'Switch to English'}
        </button>
      </div>
    </>
  );
};

export default Navbar;
